import React, { useEffect, useRef, useState } from "react";
import Joinus from "../../common/Joinus";
import { clickToWhatsAppFAQ, initialStates, servicescontent, whatsappServiceDetails } from "../home/Constant";
import ServiceMetaAni from "./ServiceMetaAni";
import Benefits from "../../common/Benefits";
import { whatsappAdds, whatsappMarketting } from "../../common/data";
import WhatsappBenifits from "./WhatsappBenifits";
import WhatWeDo from "./WhatWeDo";
import { Helmet } from "react-helmet";


const whyRunAddsClick = [
  {
    id: 1,
    title: "5X",
    content: "Increase in Lead Gen"
  },
  {
    id: 2,
    title: "5 Bn+",
    content: "Fb & Insta Users"
  },
  {
    id: 3,
    title: "2.7 Bn+",
    content: "WhatsApp Users"
  },
  {
    id: 4,
    title: "1 Click",
    content: "Lead Gen"
  }
]

const ClickToWhatsappAds = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const itemsToShow = showAll ? clickToWhatsAppFAQ : clickToWhatsAppFAQ.slice(0, 6);

  return (
    <>
      <Helmet>
        <meta name="keywords" content="whatsapp marketing agency in Chennai,WhatsApp Bulk Messaging Tool Chennai,WhatsApp Chatbot Integration India,WhatsApp Marketing CRM Tools India,Green Tick Verification Services India,whatsapp marketing service in Chennai,whatsapp marketing company in chennai,whatsapp marketing campaign
"/>
      </Helmet>
      <div className="margin-topall">
        <section className="py-5 service-position servicepadding">
          <div className="container">
            <div className="meta-bg-round">
              {colors.map((color, i) => (
                <div
                  key={i}
                  id={`dot_00${i}`}
                  style={{
                    position: "absolute",
                    border: `${i == 0 ? "9px solid white" : "none"}`,
                    top: `${initialStates[i].top}px`,
                    left: `${initialStates[i].left}px`,
                    width: `${initialStates[i].width}px`,
                    height: `${initialStates[i].height}px`,
                    marginLeft: `${initialStates[i].marginLeft}px`,
                    opacity: initialStates[i].opacity,
                    backgroundColor: color,
                    borderRadius: "50%",
                    zIndex: 1000,
                    pointerEvents: "none",
                    willChange: "top, left, width, height, opacity, margin-left",
                  }}
                />
              ))}
            </div>
            <div className="pos-z-index ">
              <div className="row justify-content-center">
                <div className="col-lg-6"
                  data-aos="fade-down" data-aos-delay="300"
                >
                  <div className="">
                    <h5 className="yellowclick-sub-heading text-center py-2">
                      Turn Clicks into Conversations with WhatsApp Services</h5>
                    {/* <h4 className="black-service-heading text-center font-align mt-3">
                    Unlock 5x Revenue Growth
                  </h4> */}
                    <div className="smsclick-sub-heading">
                      Click-to-WhatsApp Ads are interactive ads that allow users to start a real-time conversation with your business on WhatsApp with just one click. Powered by reliable WhatsApp services, these ads help businesses capture high-intent leads, increase engagement, and convert prospects faster through instant messaging on platforms like Facebook and Instagram.                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className="py-5">
        <div className="container">
          <h1 className="text-center what-head">WHAT WE DO</h1>
          <div className="row justify-content-center gap-5 py-5 alignservice" id="what_color">
            {servicescontent.map((service, index) => (
              <div className="col-md-4">
                <div className="d-flex flex-row gap-4">
                  <div className="border-dot">
                    <div className={service.dotClass}></div>
                  </div>
                  <div className="whatfont">{service.title}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}
        <WhatWeDo data={whatsappServiceDetails} />
        <WhatsappBenifits />
        <Benefits data={whatsappAdds} />
        <section className="py-5">
          <div className="container">
            <div>
              <h1 className="py-2 faqfont mb-5 text-center">Why Run Ads that Click to WhatsApp?</h1>
            </div>
            <div className="row align-items-center d-flex">
              {whyRunAddsClick.map((item, index) => (
                <div className="col-lg-3 col-md-5 col-sm-12" key={index}
                  data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`} data-aos-delay="300"
                >
                  <div className="text-center feature_content">
                    <h4>{item.title}</h4>
                    <p className="wp">{item.content}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="py-5">
          <div className="container">
            <div>
              <h1 className="py-2 faqfont mb-5">FAQs - (Click To WhatsApp Ads)</h1>
            </div>
            <div className="accordion" id="accordionExample">
              {itemsToShow.map((item, index) => (
                <div className="accordion-item border-top" key={index}
                  data-aos={`fade-${index % 2 === 1 ? "up" : "down"}`} data-aos-delay="300"
                >
                  <h2 className="accordion-header" id={`heading${item.id}`}>
                    <button
                      className={`accordion-button d-flex align-items-center ${index !== 0 ? 'collapsed' : ''
                        }`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${item.id}`}
                      aria-expanded={index === 0 ? 'true' : 'false'}
                      aria-controls={`collapse${item.id}`}
                    >
                      <span className="me-3 toggle-icon"></span>
                      {item.question}
                    </button>
                  </h2>
                  <div
                    id={`collapse${item.id}`}
                    className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                    aria-labelledby={`heading${item.id}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body wrapfaq">{item.answer}</div>
                  </div>
                </div>
              ))}
            </div>
            {clickToWhatsAppFAQ.length > 10 && (
              <div className="text-center py-3 ">
                <button
                  className="btn-sm viewbtn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            )}
          </div>
        </section>
        <Joinus />
      </div>
    </>

  );
};

export default ClickToWhatsappAds;
